/*!
 * SAPUI5
 * Copyright (c) 2025 SAP SE or an SAP affiliate company. All rights reserved.
 */
import Link from "sap/m/Link";

export function updateSortIcons(sortLinks: Map<string, Link>, activePath: string, activeOrder: string): void {
    sortLinks.forEach((link, colPath) => {
        if (colPath === activePath) {
            link.setEndIcon(
                activeOrder === "Ascending" ? "sap-icon://sort-ascending" : "sap-icon://sort-descending"
            );
        } else {
            link.setEndIcon("sap-icon://none");
        }
    });
}
